function getUnreadLeadsMsgState(state) {
  return {
    showUnreadLeadsModal: state.unreadLeadsMsg.showUnreadLeadsModal,
    postingIds: state.unreadLeadsMsg.postingIds,
    comesFromArchive: state.unreadLeadsMsg.comesFromArchive,
    sendUnreadLeadsMsgLoading: state.unreadLeadsMsg.sendUnreadLeadsMsgLoading,
    sendUnreadLeadsMsgSuccess: state.unreadLeadsMsg.sendUnreadLeadsMsgSuccess,
    sendUnreadLeadsMsgError: state.unreadLeadsMsg.sendUnreadLeadsMsgError,
    hasUnreadLeads: state.unreadLeadsMsg.hasUnreadLeads,
    hasUnreadLeadsLoading: state.unreadLeadsMsg.hasUnreadLeadsLoading,
    hasUnreadLeadsSuccess: state.unreadLeadsMsg.hasUnreadLeadsSuccess,
    hasUnreadLeadsError: state.unreadLeadsMsg.hasUnreadLeadsError,
    postingIdsToEnd: state.unreadLeadsMsg.postingIdsToEnd
  };
}

export { getUnreadLeadsMsgState };
